import React, { useState } from "react";

import { Property } from "manager/interfaces/api";
import { Input } from "shared/components/Form";
import { Modal } from "shared/components/Modal";
import useModal from "shared/hooks/useModal";

import {
  billableUnitsDiverge,
  billableUnitsDivergenceCopy,
  propertyUnitCount,
} from "./billingDisplay";
import {
  PropertySummary,
  PropertySummaryName,
  PropertySummaryUnits,
  ResetButton,
  SetLiveBody,
  WarningNote,
} from "./styled";

interface EditBillableUnitsModalProps {
  property: Property;
  submit: (payload: {
    resetToAuto: boolean;
    billableUnits?: number;
  }) => Promise<void> | void;
  submitting?: boolean;
}

const EditBillableUnitsModal = ({
  property,
  submit,
  submitting = false,
}: EditBillableUnitsModalProps) => {
  const { closeActiveModalDialog } = useModal();
  const platform = propertyUnitCount(property);
  const source = property.billableUnitsSource === "manual" ? "Manual" : "Auto";
  const current = property.billableUnits ?? platform;
  const [units, setUnits] = useState(String(current));
  const manualCount = Number(units);
  const manualOk = Number.isInteger(manualCount) && manualCount >= 0;
  const billed = manualOk ? manualCount : current;
  const showDivergence = billableUnitsDiverge(billed, platform);

  return (
    <Modal
      title="Edit billable units"
      subtitle="Lock a manual count or reset to auto."
      submit={() => submit({ resetToAuto: false, billableUnits: manualCount })}
      submitButtonLabel="Save"
      submitButtonDisabled={!manualOk}
      submitting={submitting}
      closeOnSubmit={false}
      afterClose={closeActiveModalDialog}
      showCancelLink
      width={560}
    >
      <Modal.Body>
        <SetLiveBody>
          <PropertySummary>
            <PropertySummaryName>{property.name}</PropertySummaryName>
            <PropertySummaryUnits>
              {source} {current}
            </PropertySummaryUnits>
          </PropertySummary>
          {showDivergence && (
            <WarningNote>
              {billableUnitsDivergenceCopy(billed, platform)}
            </WarningNote>
          )}
          <Input
            id="billableUnits"
            name="billableUnits"
            label="Manual count"
            type="number"
            value={units}
            onChange={(event) => setUnits(event.target.value)}
          />
          <ResetButton
            type="button"
            disabled={submitting}
            onClick={() => submit({ resetToAuto: true })}
          >
            Reset to auto
          </ResetButton>
        </SetLiveBody>
      </Modal.Body>
    </Modal>
  );
};

export default EditBillableUnitsModal;
